if (typeof document !== "undefined") {
  const code = '@import url("https://fonts.googleapis.com/css2?family=Material+Icons");@import url("https://fonts.googleapis.com/css2?family=Material+Icons+Outlined");@import url("https://fonts.googleapis.com/css2?family=Material+Icons+Round");@import url("https://fonts.googleapis.com/css2?family=Material+Icons+Sharp");@import url("https://fonts.googleapis.com/css2?family=Material+Icons+Two+Tone");';
  const styleEl = document.createElement("style");
  const codeEl = document.createTextNode(code);
  styleEl.type = "text/css";
  styleEl.appendChild(codeEl);
  document.head.appendChild(styleEl);
}
